// src/components/layout/Sidebar.js
import {
  ChevronDown,
  ChevronUp,
} from "lucide-react";

function Sidebar({
  sidebarOpen,
  navigate,
  logo,
  signOut,
  profileOpen,
  setProfileOpen,
  payrollOpen,
  setPayrollOpen,
  formsOpen,
  setFormsOpen,
}) {
  return (
    <aside
      className={`fixed z-40 top-0 left-0 h-full w-64 bg-white shadow-md flex flex-col transition-transform transform
        ${sidebarOpen ? "translate-x-0" : "-translate-x-full"} md:translate-x-0`}
    >
      {/* Logo */}
      <div
        className="flex items-center justify-center p-4 border-b cursor-pointer"
        onClick={() => navigate("/dashboard")}
      >
        <img src={logo} alt="Logo" className="h-12" />
      </div>

      {/* Navigation */}
      <nav className="flex-1 p-4 space-y-2 text-sm overflow-y-auto">
        {/* STINTE Knowldege Base */}
        <button
          className="w-full text-left px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          onClick={() => window.open("https://app.trainual.com/a917d99d-0f31-459a-9455-bf611b1ae573/users/sign_in", "_blank")}
        >
          STINTE KNOWLEDGE BASE
        </button>

        {/* CONTACT */}
        <button
          className="w-full text-left px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          onClick={() => navigate("/contact_info")}
        >
          CONTACT INFORMATION
        </button>

        {/* GOOGLE */}
        <button
          className="w-full text-left px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          onClick={() => window.open("https://mail.google.com", "_blank")}
        >
          GOOGLE EMAIL
        </button>

        <button
          className="w-full text-left px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          onClick={() => window.open("https://chat.google.com", "_blank")}
        >
          GOOGLE CHAT
        </button>

        {/* NEWSBOARD */}
        <button
          className="w-full text-left px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          onClick={() => navigate("/newsboard")}
        >
          NEWSBOARD
        </button>

        {/* PROFILE */}
        <div>
          <button
            onClick={() => setProfileOpen(!profileOpen)}
            className="w-full flex justify-between items-center px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          >
            PROFILE
            {profileOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>

          {profileOpen && (
            <div className="pl-6 space-y-1 mt-1">
              <button
                className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                onClick={() =>
                  window.open(
                    "https://www.employeenavigator.com/identity/Account/Login?ReturnUrl=%2Fidentity%2Fconnect%2Fauthorize%2Fcallback%3FauthzId%3D00E8DBDAFBAC07BB0EA97D03C0F01AD5ECA0088C492BD4ED170106E1A7FF7DFC",
                    "_blank"
                  )
                }
              >
                Insurance
              </button>

              <button
                onClick={() => setPayrollOpen(!payrollOpen)}
                className="w-full flex justify-between items-center px-2 py-1 rounded hover:bg-gray-100 font-bold text-lg"
              >
                PAY ROLL
                {payrollOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
              </button>

              {payrollOpen && (
                <div className="pl-6 space-y-1 mt-1">
                  <button
                    className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                    onClick={() =>
                      window.open(
                        "https://identity.myisolved.com/",
                        "_blank"
                      )
                    }
                  >
                    Isolved
                  </button>

                  <button
                    className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                    onClick={() =>
                      window.open(
                        "/STINTE_Employee_PTO_Compensation_Standards.pdf",
                        "_blank"
                      )
                    }
                  >
                    PTO Compensation Standards
                  </button>

                  <button
                    className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                    onClick={() =>
                      window.open(
                        "\\Paid Time Off Policy HR-300-01-v2.2.pdf",
                        "_blank"
                      )
                    }
                  >
                    PTO & Holiday Policy
                  </button>

                  <button
                    className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                    onClick={() =>
                      window.open(
                        "\\PTO Policy_Addendum 3.2.2026.pdf",
                        "_blank"
                      )
                    }
                  >
                    PTO & Holiday Policy Update
                  </button>

                  <button
                    className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                    onClick={() =>
                      window.open(
                        "\\PTO Addendum Technicians HR-300-02-v1.0.pdf",
                        "_blank"
                      )
                    }
                  >
                    PTO Policy Addendum
                  </button>

                </div>
              )}
            </div>
          )}
        </div>

        {/* FORMS */}
        <div>
          <button
            onClick={() => setFormsOpen(!formsOpen)}
            className="w-full flex justify-between items-center px-4 py-2 rounded hover:bg-gray-200 font-bold text-xl"
          >
            FORMS
            {formsOpen ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
          </button>

          {formsOpen && (
                        <div className="pl-6 space-y-1 mt-1">
                            <button
                                className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                                onClick={() =>
                                    window.open(
                                        "https://forms.gle/AYbL8dccaKBquM5x8",
                                        "_blank"
                                    )
                                }
                            >
                                Coaching Feedback
                            </button>
                            <button
                              className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                              onClick={() => window.open("/handbook.pdf", "_blank")}
                            >
                              Employee Handbook
                            </button>

                            <button
                                className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                                onClick={() =>
                                    window.open(
                                        "https://forms.gle/1AL9kuBbmbqP1gED8",
                                        "_blank"
                                    )
                                }
                            >
                                Emplolyee Of The Month
                            </button>
                            <button
                                className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                                onClick={() =>
                                    window.open(
                                        "https://docs.google.com/forms/d/e/1FAIpQLSfkb2mdrs3wqayM6ZWv5kw4_8kFsl0cFGlbWc3b4C5nNzcmgA/viewform",
                                        "_blank"
                                    )
                                }
                            >
                                Suggestion
                            </button>
                            <button
                                className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                                onClick={() =>
                                    window.open(
                                        "https://docs.google.com/forms/d/e/1FAIpQLSc_vJzpf9x_sBFSd3a9ny6WPEltUjoCfHwKgl5Sls20vKkXkw/viewform",
                                        "_blank"
                                    )
                                }
                            >
                                Time Off Requests
                            </button>
                            <button
                                className="block w-full text-center px-2 py-1 rounded hover:bg-gray-100 font-medium text-lg"
                                onClick={() =>
                                    window.open(
                                        "https://docs.google.com/forms/d/e/1FAIpQLSep6PBTL6yrsDCXiFcMNJDfUnNw0nJOunglacrDmCbqwSI60A/viewform",
                                        "_blank"
                                    )
                                }
                            >
                                Tool Purchase Request
                            </button>
                        </div>
                    )}
                </div>
      </nav>

      {/* Sign Out */}
      <div className="p-4 border-t">
        <button
          onClick={signOut}
          className="w-full px-4 py-2 bg-red-600 text-white rounded hover:bg-red-700"
        >
          Sign Out
        </button>
      </div>
    </aside>
  );
}

export default Sidebar;
